const Textarea = ({ id, label, name,value, onChange,defaultView=false, readOnly = false, style = {} }) => (
  <div className="form-floating">
    <textarea
    className={`form-control p-2 defaulttextareaheight ${readOnly ? "custom-readonly" : ""}`}
      // className="form-control p-2 defaulttextareaheight"
      id={id}
      name={name}
      readOnly={readOnly}
      style={{ fontSize: "0.8rem", ...style }}
      placeholder={label}
      value={value}
      onChange={onChange}
    />
    <label
      htmlFor={id}
      className={`align-items-start ${defaultView ? 'greybg' : readOnly ? "customBG" : ""}`}
      style={{
        fontSize: "0.8rem",
        color: "#212529a6",
        padding: "0.44rem 0.75rem"
      }}
    >
      {label}
    </label>
  </div>
);

export default Textarea;
